import React from 'react';
import {
	object,
	func,
	bool,
	string,
	oneOfType
} from 'prop-types';

import QuizEditorContainer from '../../molecules/Editor/QuizEditorContainer';
import Presenter from './Presenter';
import ErrorPresenter from './ErrorPresenter';
import MobilePresenter from './MobilePresenter';
import Container from './Container';
import { Mobile, Default } from '../../Sizes';

const CreateQuizModal = ({ recipeId, quiz, show, onHide, onSave, onSaveNew, error }) => {
	if(!show) return null;
	if(error) return <ErrorPresenter 
		onHide={onHide}
		show={show}
		error={error}
	/>;
	return (<QuizEditorContainer
		key={quiz || show}
		initText={quiz && quiz.question}
		render={({ editorProps : editor, plainText }) => {
			return <Container
				editText={plainText}
				quiz={quiz}
				recipeId={recipeId}
				onSave={onSave}
				onHide={onHide}
				onSaveNew={onSaveNew}
				editorProps={editor}
				render={({
					previewProps,
					expanderProps,
					optionProps,
					onCheckSample,
					isSample,
					onSubmit,
					editorProps,
					...other
				}) => {
					return (
						<React.Fragment>
							<Default>
								<Presenter
									isEdit={!!quiz}
									show={show}
									editorProps={editorProps}
									expanderProps={expanderProps}
									previewProps={previewProps}
									optionProps={optionProps}
									onHide={onHide}
									onSave={onSubmit}
									onCheckSample={onCheckSample}
									isSample={isSample}
									{...other}
								/>
							</Default>
							<Mobile>
								<MobilePresenter 
									isEdit={!!quiz}
									show={show}
									editorProps={editorProps}
									expanderProps={expanderProps}
									previewProps={previewProps}
									optionProps={optionProps}
									onHide={onHide}
									onSave={onSubmit}
									onCheckSample={onCheckSample}
									isSample={isSample}
									{...other}
								/>

							</Mobile>
						</React.Fragment>
					);
				}}
			/>;
		}}
	/>);
};


CreateQuizModal.propTypes = {
	quiz: object,
	show: bool,
	onHide: func.isRequired,
	onSave: func.isRequired,
	onSaveNew: func.isRequired,
	recipeId:string,
	error: oneOfType([object,string])
};

export default CreateQuizModal;